export const TERMS_PDF_URL = 'https://zoolife.tv/assets/terms-of-use-v17-03-2021.pdf';
export const PRIVACY_PDF_URL = 'https://zoolife.tv/assets/privacy-policy-v17-03-2021.pdf';
